import { CAMPAIGNS } from "../lib/constants/actions";
export const campaign = (state = {}, action) => {

    switch (action.type) {
        case CAMPAIGNS.GET_CAMPAIGNS_SUCCESS:
            if (action.payload && action.payload.userId)
                return { ...state, [`usersCampaign-${action.payload.userId}`]: action.payload.result }
            else
                return state;
        case CAMPAIGNS.GET_CAMPAIGNS_DATA_SUCCESS:
            return { ...state, details: action.payload }

        case CAMPAIGNS.CHANGE_STATUS_SUCCESS:
            return { ...state, statusUpdated: action.payload }

        case CAMPAIGNS.GET_CAMPAIGN_CHARGES_SUCCESS:
            return { ...state, charges: action.payload }

        case CAMPAIGNS.SAVE_CAMPAIGN_CHARGES_SUCCESS:
            return { ...state, chargesUpdated: action.payload }

        case CAMPAIGNS.GET_INTEREST_SUCCESS:
            return { ...state, interests: action.payload }

        case CAMPAIGNS.SAVE_INTEREST_SUCCESS:
            return { ...state, interestSaved: action.payload }


        case CAMPAIGNS.DELETE_INTEREST_SUCCESS:
            return { ...state, interestDeleted: action.payload }

        case CAMPAIGNS.GET_TRANSACTION_HISTORY_SUCCESS:
            return { ...state, transactionHistory: action.payload }

        case CAMPAIGNS.GET_CAMPAIGN_USER_SUCCESS:
            return { ...state, campaignUsers: action.payload }

        case CAMPAIGNS.APPROVE_CAMPAIGN_SUCCESS:
            return { ...state, campaignApproved: action.payload }

        ///


        case CAMPAIGNS.SAVE_CAMPAIGN_SETTING_SUCCESS:
            return { ...state, campaignSettingSaved: action.payload }

        case CAMPAIGNS.GET_CAMPAIGN_SETTING_SUCCESS:
            return { ...state, campaignSettingsList: action.payload }

        case CAMPAIGNS.DELETE_CAMPAIGN_SETTING_SUCCESS:
            return { ...state, campaignSettingDeleted: action.payload }

            case CAMPAIGNS.GET_CAMPAIGN_INSIGHT_SUCCESS:
            return { ...state, campaignInsight: action.payload }

        default:
            return state;
    }
};




